import React, { useCallback, useEffect, useMemo, useState } from 'react';
import api from '../services/api';

const s = {
  title: { fontSize:22, fontWeight:600, color:'#f1f5f9', marginBottom:4 },
  sub: { fontSize:13, color:'#64748b', marginBottom:22 },
  tabs: { display:'flex', gap:4, marginBottom:20, borderBottom:'1px solid #334155', flexWrap:'wrap' },
  tab: a => ({ padding:'9px 14px', cursor:'pointer', fontSize:13, fontWeight:600, color:a?'#38bdf8':'#94a3b8', background:'transparent', border:'none', borderBottom:`2px solid ${a?'#38bdf8':'transparent'}` }),
  toolbar: { display:'flex', gap:10, alignItems:'center', flexWrap:'wrap', marginBottom:16 },
  grid2: { display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:16 },
  grid4: { display:'grid', gridTemplateColumns:'repeat(4, minmax(0, 1fr))', gap:12, marginBottom:16 },
  card: { background:'#1e293b', border:'1px solid #334155', borderRadius:8, padding:18 },
  cardTit: { fontSize:12, fontWeight:700, color:'#94a3b8', textTransform:'uppercase', marginBottom:10 },
  kpi: { fontSize:28, fontWeight:800, color:'#38bdf8' },
  hint: { fontSize:12, color:'#64748b', marginTop:4 },
  input: { background:'#0f172a', border:'1px solid #334155', color:'#f1f5f9', borderRadius:8, padding:'9px 11px', fontSize:13, outline:'none' },
  select: { background:'#0f172a', border:'1px solid #334155', color:'#f1f5f9', borderRadius:8, padding:'9px 11px', fontSize:13 },
  textarea: { width:'100%', minHeight:86, background:'#0f172a', border:'1px solid #334155', color:'#f1f5f9', borderRadius:8, padding:'10px 12px', fontSize:13, outline:'none', resize:'vertical', fontFamily:'inherit' },
  label: { display:'block', color:'#94a3b8', fontSize:12, fontWeight:700, marginBottom:6 },
  btn: { background:'#0ea5e9', color:'#fff', border:'none', borderRadius:8, padding:'9px 14px', fontSize:13, fontWeight:700, cursor:'pointer' },
  btn2: { background:'#1e293b', color:'#cbd5e1', border:'1px solid #334155', borderRadius:8, padding:'8px 12px', fontSize:12, fontWeight:700, cursor:'pointer' },
  danger: { background:'rgba(239,68,68,.12)', color:'#f87171', border:'1px solid rgba(239,68,68,.28)', borderRadius:8, padding:'8px 12px', fontSize:12, fontWeight:700, cursor:'pointer' },
  table: { width:'100%', borderCollapse:'collapse' },
  th: { fontSize:11, color:'#64748b', textAlign:'left', padding:'8px', borderBottom:'1px solid #334155', textTransform:'uppercase' },
  td: { fontSize:12, color:'#cbd5e1', padding:'8px', borderBottom:'1px solid #172033', verticalAlign:'top' },
  badge: color => ({ display:'inline-block', background:`${color}22`, color, border:`1px solid ${color}40`, padding:'2px 8px', borderRadius:999, fontSize:11, fontWeight:700 }),
  empty: { color:'#64748b', fontSize:13, padding:24, textAlign:'center' },
  formGrid: { display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:12 },
};

const TABS = [
  ['status','Status'],
  ['avisos','Avisos'],
  ['interacoes','Interacoes'],
  ['config','Configurar'],
  ['relatorios','Relatorios'],
  ['base','Base de conhecimento'],
  ['regras','Regras da IA'],
];

const prioridadeCor = { alta:'#ef4444', media:'#f59e0b', baixa:'#22c55e' };
const sentimentoCor = { positivo:'#22c55e', neutro:'#94a3b8', negativo:'#ef4444' };

function Kpi({ label, value, hint, color = '#38bdf8' }) {
  return (
    <div style={s.card}>
      <div style={s.cardTit}>{label}</div>
      <div style={{ ...s.kpi, color }}>{value ?? 0}</div>
      {hint && <div style={s.hint}>{hint}</div>}
    </div>
  );
}

function Toggle({ value, onChange, label }) {
  return (
    <button type="button" style={value ? s.btn : s.btn2} onClick={() => onChange(!value)}>
      {label}: {value ? 'Ativo' : 'Inativo'}
    </button>
  );
}

function BaseForm({ atual, onCancel, onSave }) {
  const [form, setForm] = useState(atual || { categoria:'Cursos', titulo:'', conteudo:'', ativo:true });
  return (
    <div style={s.card}>
      <div style={s.formGrid}>
        <div>
          <label style={s.label}>Categoria</label>
          <input style={{ ...s.input, width:'100%' }} value={form.categoria} onChange={e=>setForm(f=>({...f,categoria:e.target.value}))} />
        </div>
        <div>
          <label style={s.label}>Titulo</label>
          <input style={{ ...s.input, width:'100%' }} value={form.titulo} onChange={e=>setForm(f=>({...f,titulo:e.target.value}))} />
        </div>
      </div>
      <label style={s.label}>Conteudo oficial para a IA</label>
      <textarea style={s.textarea} value={form.conteudo} onChange={e=>setForm(f=>({...f,conteudo:e.target.value}))} />
      <div style={s.toolbar}>
        <Toggle value={form.ativo} onChange={v=>setForm(f=>({...f,ativo:v}))} label="Item" />
        <button style={s.btn} onClick={()=>onSave(form)}>Salvar</button>
        <button style={s.btn2} onClick={onCancel}>Cancelar</button>
      </div>
    </div>
  );
}

function RegraForm({ atual, onCancel, onSave }) {
  const [form, setForm] = useState(atual || { titulo:'', descricao:'', tipo:'orientacao', bloqueante:true, ativo:true });
  return (
    <div style={s.card}>
      <div style={s.formGrid}>
        <div>
          <label style={s.label}>Titulo</label>
          <input style={{ ...s.input, width:'100%' }} value={form.titulo} onChange={e=>setForm(f=>({...f,titulo:e.target.value}))} />
        </div>
        <div>
          <label style={s.label}>Tipo</label>
          <select style={{ ...s.select, width:'100%' }} value={form.tipo} onChange={e=>setForm(f=>({...f,tipo:e.target.value}))}>
            <option value="limite">Limite</option>
            <option value="orientacao">Orientacao</option>
            <option value="auditoria">Auditoria</option>
          </select>
        </div>
      </div>
      <label style={s.label}>Descricao</label>
      <textarea style={s.textarea} value={form.descricao} onChange={e=>setForm(f=>({...f,descricao:e.target.value}))} />
      <div style={s.toolbar}>
        <Toggle value={form.bloqueante} onChange={v=>setForm(f=>({...f,bloqueante:v}))} label="Bloqueante" />
        <Toggle value={form.ativo} onChange={v=>setForm(f=>({...f,ativo:v}))} label="Regra" />
        <button style={s.btn} onClick={()=>onSave(form)}>Salvar</button>
        <button style={s.btn2} onClick={onCancel}>Cancelar</button>
      </div>
    </div>
  );
}

function ConfigForm({ config, onSave }) {
  const [form, setForm] = useState(config || {});
  useEffect(() => setForm(config || {}), [config]);
  if (!config) return <div style={s.empty}>Selecione uma instancia para configurar.</div>;
  const modelosPadrao = {
    gemini: 'gemini-2.5-flash',
    openrouter: 'openai/gpt-4o-mini',
    openai: 'gpt-4o-mini',
    claude: 'claude-3-5-haiku-latest',
  };
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const trocarProvedor = provider => setForm(f => ({
    ...f,
    llm_provider: provider,
    llm_model: f.llm_model || modelosPadrao[provider] || ''
  }));
  const provider = form.llm_provider || 'gemini';
  const chaveConfigurada = form.has_llm_api_key || form.has_gemini_api_key || Boolean(config?.has_llm_api_key || config?.has_gemini_api_key);
  const linkChave = provider === 'openai'
    ? 'https://platform.openai.com/api-keys'
    : provider === 'openrouter'
      ? 'https://openrouter.ai/settings/keys'
      : provider === 'claude'
        ? 'https://console.anthropic.com/settings/keys'
        : 'https://aistudio.google.com/app/apikey';
  return (
    <div style={s.card}>
      <div style={s.cardTit}>{form.instance_name}</div>
      <div style={{ background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:14, marginBottom:14 }}>
        <div style={{ display:'flex', justifyContent:'space-between', gap:12, alignItems:'center', flexWrap:'wrap' }}>
          <div>
            <div style={{ color:'#f1f5f9', fontWeight:800, fontSize:14 }}>Provedor de IA desta instancia</div>
            <div style={{ color:'#94a3b8', fontSize:12, marginTop:4 }}>
              Usado em campanhas, respostas IA e automacoes deste atendente. Voce pode usar Gemini, OpenRouter, OpenAI ou Claude.
            </div>
          </div>
          <span style={s.badge(chaveConfigurada ? '#22c55e' : '#f59e0b')}>
            {chaveConfigurada ? 'Chave configurada' : 'Sem chave nesta instancia'}
          </span>
        </div>
        <div style={s.formGrid}>
          <div>
            <label style={{ ...s.label, marginTop:12 }}>Provedor</label>
            <select style={{ ...s.select, width:'100%' }} value={provider} onChange={e=>trocarProvedor(e.target.value)}>
              <option value="gemini">Gemini</option>
              <option value="openrouter">OpenRouter</option>
              <option value="openai">OpenAI</option>
              <option value="claude">Claude / Anthropic</option>
            </select>
          </div>
          <div>
            <label style={{ ...s.label, marginTop:12 }}>Modelo</label>
            <input style={{ ...s.input, width:'100%' }} value={form.llm_model || modelosPadrao[provider] || ''} onChange={e=>set('llm_model',e.target.value)} />
          </div>
        </div>
        <label style={{ ...s.label, marginTop:12 }}>Chave API deste provedor</label>
        <input style={{ ...s.input, width:'100%' }} type="password" value={form.llm_api_key || ''} placeholder={chaveConfigurada ? 'Chave ja configurada. Preencha apenas para trocar.' : 'Cole a chave API deste atendente'} onChange={e=>set('llm_api_key',e.target.value)} />
        <div style={{ display:'flex', gap:8, alignItems:'center', flexWrap:'wrap', marginTop:10 }}>
          <span style={s.hint}>Modelo recomendado: {modelosPadrao[provider]}</span>
          <a href={linkChave} target="_blank" rel="noreferrer" style={{ color:'#38bdf8', fontSize:12, fontWeight:700 }}>Abrir pagina de chaves</a>
          <button type="button" style={{ ...s.btn, padding:'7px 12px', fontSize:12 }} onClick={()=>onSave(form)}>
            Salvar IA desta instancia
          </button>
        </div>
      </div>
      <div style={s.formGrid}>
        <div><label style={s.label}>Inicio</label><input style={{...s.input,width:'100%'}} type="time" value={form.horario_inicio || '08:00'} onChange={e=>set('horario_inicio',e.target.value)} /></div>
        <div><label style={s.label}>Fim</label><input style={{...s.input,width:'100%'}} type="time" value={form.horario_fim || '18:00'} onChange={e=>set('horario_fim',e.target.value)} /></div>
        <div><label style={s.label}>E-mail do relatorio</label><input style={{...s.input,width:'100%'}} value={form.email_relatorio || ''} onChange={e=>set('email_relatorio',e.target.value)} /></div>
        <div><label style={s.label}>Modelo Gemini legado</label><input style={{...s.input,width:'100%'}} value={form.gemini_model || 'gemini-2.5-flash'} onChange={e=>set('gemini_model',e.target.value)} /></div>
        <div><label style={s.label}>Tempo max. sem resposta (min)</label><input style={{...s.input,width:'100%'}} type="number" value={form.tempo_sem_resposta_min || 30} onChange={e=>set('tempo_sem_resposta_min',Number(e.target.value))} /></div>
        <div><label style={s.label}>Tempo max. sem atividade (min)</label><input style={{...s.input,width:'100%'}} type="number" value={form.tempo_sem_atividade_min || 60} onChange={e=>set('tempo_sem_atividade_min',Number(e.target.value))} /></div>
        <div><label style={s.label}>Intervalo de analise (min)</label><input style={{...s.input,width:'100%'}} type="number" value={form.intervalo_analise_min || 15} onChange={e=>set('intervalo_analise_min',Number(e.target.value))} /></div>
        <div><label style={s.label}>Hora do relatorio diario</label><input style={{...s.input,width:'100%'}} type="time" value={form.relatorio_diario_hora || '18:30'} onChange={e=>set('relatorio_diario_hora',e.target.value)} /></div>
      </div>
      <label style={s.label}>Prompt do sistema</label>
      <textarea style={s.textarea} value={form.system_prompt || ''} onChange={e=>set('system_prompt',e.target.value)} />
      <div style={s.toolbar}>
        <Toggle value={form.analise_automatica !== false} onChange={v=>set('analise_automatica',v)} label="Analise automatica" />
        <Toggle value={form.relatorio_diario_ativo === true} onChange={v=>set('relatorio_diario_ativo',v)} label="Relatorio diario" />
        <Toggle value={form.monitorar !== false} onChange={v=>set('monitorar',v)} label="Monitorar instancia" />
        <span style={s.badge('#ef4444')}>Envio automatico bloqueado</span>
        <button style={s.btn} onClick={()=>onSave(form)}>Salvar configuracao</button>
      </div>
    </div>
  );
}

export default function GestorIA() {
  const [aba, setAba] = useState('status');
  const [status, setStatus] = useState(null);
  const [avisos, setAvisos] = useState([]);
  const [analises, setAnalises] = useState([]);
  const [configs, setConfigs] = useState([]);
  const [configSel, setConfigSel] = useState(null);
  const [base, setBase] = useState([]);
  const [regras, setRegras] = useState([]);
  const [relatorios, setRelatorios] = useState([]);
  const [baseEdit, setBaseEdit] = useState(null);
  const [regraEdit, setRegraEdit] = useState(null);
  const [filtros, setFiltros] = useState({ status:'', prioridade:'', atendente_id:'' });
  const [loading, setLoading] = useState(false);
  const [configMsg, setConfigMsg] = useState(null);

  const carregar = useCallback(async () => {
    const [st, av, an, cfg, bc, rg, rel] = await Promise.all([
      api.get('/gestor/supervisor/status').catch(()=>({data:null})),
      api.get('/gestor/avisos').catch(()=>({data:[]})),
      api.get('/gestor/analises').catch(()=>({data:[]})),
      api.get('/gestor/configs').catch(()=>({data:[]})),
      api.get('/gestor/base-conhecimento').catch(()=>({data:[]})),
      api.get('/gestor/regras').catch(()=>({data:[]})),
      api.get('/gestor/relatorios').catch(()=>({data:[]})),
    ]);
    setStatus(st.data);
    setAvisos(av.data || []);
    setAnalises(an.data || []);
    setConfigs(cfg.data || []);
    setBase(bc.data || []);
    setRegras(rg.data || []);
    setRelatorios(rel.data || []);
    setConfigSel(prev => prev || (cfg.data || [])[0] || null);
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  const analisesFiltradas = useMemo(() => analises.filter(a =>
    (!filtros.status || a.status_lead === filtros.status) &&
    (!filtros.prioridade || a.prioridade === filtros.prioridade)
  ), [analises, filtros]);

  const executarAnaliseDia = async () => {
    setLoading(true);
    try {
      await api.post('/gestor/analisar/dia');
      await carregar();
      setAba('interacoes');
    } finally {
      setLoading(false);
    }
  };

  const gerarRelatorio = async () => {
    setLoading(true);
    try {
      await api.post('/gestor/relatorios/gerar', {});
      await carregar();
      setAba('relatorios');
    } finally {
      setLoading(false);
    }
  };

  const marcarLido = async id => {
    await api.patch(`/gestor/avisos/${id}/lido`);
    setAvisos(prev => prev.filter(a => a.id !== id));
  };

  const salvarConfig = async form => {
    setConfigMsg({ ok:true, txt:'Salvando configuracao...' });
    try {
      await api.patch(`/gestor/config/${encodeURIComponent(form.instance_name)}`, form);
      await carregar();
      setConfigMsg({ ok:true, txt:'Configuracao salva. Provedor de IA atualizado para esta instancia.' });
    } catch (e) {
      setConfigMsg({ ok:false, txt:e.response?.data?.error || 'Erro ao salvar configuracao.' });
    }
  };

  const salvarBase = async form => {
    if (form.id) await api.patch(`/gestor/base-conhecimento/${form.id}`, form);
    else await api.post('/gestor/base-conhecimento', form);
    setBaseEdit(null);
    await carregar();
  };

  const salvarRegra = async form => {
    if (form.id) await api.patch(`/gestor/regras/${form.id}`, form);
    else await api.post('/gestor/regras', form);
    setRegraEdit(null);
    await carregar();
  };

  return (
    <div>
      <div style={s.title}>Gestor IA</div>
      <div style={s.sub}>Supervisao inteligente das conversas do Grupo D1 Carreiras. Analisa, alerta e sugere acoes sem enviar mensagens automaticamente.</div>

      <div style={s.tabs}>
        {TABS.map(([k,l]) => (
          <button key={k} style={s.tab(aba===k)} onClick={()=>setAba(k)}>
            {l}{k==='avisos' && avisos.length > 0 ? ` (${avisos.length})` : ''}
          </button>
        ))}
      </div>

      {aba === 'status' && (
        <>
          <div style={s.toolbar}>
            <button style={s.btn} onClick={executarAnaliseDia} disabled={loading}>{loading ? 'Analisando...' : 'Executar analise do dia'}</button>
            <button style={s.btn2} onClick={gerarRelatorio}>Gerar relatorio diario</button>
            <button style={s.btn2} onClick={carregar}>Atualizar</button>
          </div>
          <div style={s.grid4}>
            <Kpi label="Instancias conectadas" value={status?.instancias_conectadas} hint={`${status?.instancias?.length || 0} monitoradas`} />
            <Kpi label="Atendentes ativos" value={status?.atendentes_ativos} />
            <Kpi label="Conversas em andamento" value={status?.conversas_em_andamento} />
            <Kpi label="Conversas paradas" value={status?.conversas_paradas} color="#f59e0b" />
            <Kpi label="Leads sem resposta" value={status?.leads_sem_resposta} color="#f59e0b" />
            <Kpi label="Intencao de matricula" value={status?.leads_intencao_matricula} color="#22c55e" />
            <Kpi label="Pediram preco" value={status?.clientes_pediram_preco} />
            <Kpi label="Precisam humano" value={status?.precisam_humano} color="#ef4444" />
          </div>
          <div style={s.grid2}>
            <div style={s.card}>
              <div style={s.cardTit}>Instancias</div>
              <table style={s.table}><tbody>
                {(status?.instancias || []).map(i => (
                  <tr key={i.instance_name}>
                    <td style={s.td}>{i.instance_name}</td>
                    <td style={s.td}><span style={s.badge(i.status_instancia==='open'?'#22c55e':'#ef4444')}>{i.status_instancia || 'offline'}</span></td>
                    <td style={s.td}>{i.monitorar ? 'Monitorando' : 'Pausada'}</td>
                  </tr>
                ))}
              </tbody></table>
            </div>
            <div style={s.card}>
              <div style={s.cardTit}>Ultima analise IA</div>
              <div style={{ color:'#cbd5e1', fontSize:14 }}>{status?.ultima_analise ? new Date(status.ultima_analise).toLocaleString('pt-BR') : 'Ainda nao executada'}</div>
              <div style={s.hint}>Erros de conexao: {status?.erros_conexao || 0} · Campanhas ativas: {status?.campanhas_ativas || 0} · Avisos pendentes: {status?.avisos_pendentes || 0}</div>
            </div>
          </div>
        </>
      )}

      {aba === 'avisos' && (
        <div style={s.card}>
          {avisos.length === 0 && <div style={s.empty}>Nenhum aviso pendente.</div>}
          <table style={s.table}>
            <thead><tr>{['Tipo','Mensagem','Atendente','Cliente','Criado','Acao'].map(h=><th key={h} style={s.th}>{h}</th>)}</tr></thead>
            <tbody>{avisos.map(a => (
              <tr key={a.id}>
                <td style={s.td}><span style={s.badge('#f59e0b')}>{a.tipo_aviso}</span></td>
                <td style={s.td}>{a.mensagem}</td>
                <td style={s.td}>{a.atendente_nome || '-'}</td>
                <td style={s.td}>{a.contato_nome || a.phone}</td>
                <td style={s.td}>{new Date(a.created_at).toLocaleString('pt-BR')}</td>
                <td style={s.td}><button style={s.btn2} onClick={()=>marcarLido(a.id)}>Marcar resolvido</button></td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}

      {aba === 'interacoes' && (
        <>
          <div style={s.toolbar}>
            <select style={s.select} value={filtros.status} onChange={e=>setFiltros(f=>({...f,status:e.target.value}))}>
              <option value="">Todos status</option>
              {[...new Set(analises.map(a=>a.status_lead))].filter(Boolean).map(v=><option key={v} value={v}>{v}</option>)}
            </select>
            <select style={s.select} value={filtros.prioridade} onChange={e=>setFiltros(f=>({...f,prioridade:e.target.value}))}>
              <option value="">Todas prioridades</option>
              <option value="alta">Alta</option>
              <option value="media">Media</option>
              <option value="baixa">Baixa</option>
            </select>
            <button style={s.btn2} onClick={executarAnaliseDia}>Reanalisar hoje</button>
          </div>
          <div style={s.card}>
            <table style={s.table}>
              <thead><tr>{['Cliente','Atendente','Ultima mensagem','Resumo','Status','Sentimento','Proxima acao','Prioridade','Analise'].map(h=><th key={h} style={s.th}>{h}</th>)}</tr></thead>
              <tbody>{analisesFiltradas.map(a => (
                <tr key={a.id}>
                  <td style={s.td}>{a.contato_nome || a.phone}</td>
                  <td style={s.td}>{a.atendente_nome || '-'}</td>
                  <td style={{...s.td, maxWidth:180}}>{a.ultima_mensagem || '-'}</td>
                  <td style={{...s.td, maxWidth:260}}>{a.resumo}</td>
                  <td style={s.td}><span style={s.badge('#38bdf8')}>{a.status_lead}</span></td>
                  <td style={s.td}><span style={s.badge(sentimentoCor[a.sentimento] || '#94a3b8')}>{a.sentimento}</span></td>
                  <td style={s.td}>{a.proxima_acao}</td>
                  <td style={s.td}><span style={s.badge(prioridadeCor[a.prioridade] || '#94a3b8')}>{a.prioridade}</span></td>
                  <td style={s.td}>{new Date(a.analisado_em).toLocaleString('pt-BR')}</td>
                </tr>
              ))}</tbody>
            </table>
            {analisesFiltradas.length === 0 && <div style={s.empty}>Nenhuma analise ainda. Clique em Executar analise do dia.</div>}
          </div>
        </>
      )}

      {aba === 'config' && (
        <div style={s.grid2}>
          <div style={s.card}>
            <div style={s.cardTit}>Instancias monitoradas</div>
            {configs.map(c => (
              <button key={c.instance_name} style={{ ...s.btn2, width:'100%', marginBottom:8, textAlign:'left', borderColor:configSel?.instance_name===c.instance_name?'#38bdf8':'#334155' }} onClick={()=>setConfigSel(c)}>
                {c.instance_name} · {c.monitorar !== false ? 'monitorando' : 'pausada'}
              </button>
            ))}
          </div>
          <div>
            {configMsg && <div style={configMsg.ok ? { ...s.card, color:'#22c55e', marginBottom:12, padding:12 } : { ...s.card, color:'#f87171', marginBottom:12, padding:12 }}>{configMsg.txt}</div>}
            <ConfigForm config={configSel} onSave={salvarConfig} />
          </div>
        </div>
      )}

      {aba === 'relatorios' && (
        <>
          <div style={s.toolbar}><button style={s.btn} onClick={gerarRelatorio}>Gerar relatorio de hoje</button></div>
          <div style={s.card}>
            <table style={s.table}>
              <thead><tr>{['Data','Conversas','Enviadas','Recebidas','Possiveis matriculas','Alertas','E-mail'].map(h=><th key={h} style={s.th}>{h}</th>)}</tr></thead>
              <tbody>{relatorios.map(r => (
                <tr key={r.id}>
                  <td style={s.td}>{new Date(r.data).toLocaleDateString('pt-BR')}</td>
                  <td style={s.td}>{r.resumo_geral?.total_conversas || 0}</td>
                  <td style={s.td}>{r.resumo_geral?.mensagens_enviadas || 0}</td>
                  <td style={s.td}>{r.resumo_geral?.mensagens_recebidas || 0}</td>
                  <td style={s.td}>{r.resumo_geral?.possiveis_matriculas || 0}</td>
                  <td style={s.td}>{r.resumo_ia?.alertas_gerados || 0}</td>
                  <td style={s.td}>{r.enviado ? `Enviado para ${r.enviado_para}` : 'Preparado, nao enviado'}</td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        </>
      )}

      {aba === 'base' && (
        <>
          <div style={s.toolbar}><button style={s.btn} onClick={()=>setBaseEdit({ categoria:'Cursos', titulo:'', conteudo:'', ativo:true })}>Novo item</button></div>
          {baseEdit && <BaseForm atual={baseEdit.id ? baseEdit : null} onCancel={()=>setBaseEdit(null)} onSave={salvarBase} />}
          <div style={s.grid2}>{base.map(item => (
            <div key={item.id} style={s.card}>
              <div style={s.cardTit}>{item.categoria}</div>
              <div style={{ color:'#f1f5f9', fontWeight:700, marginBottom:8 }}>{item.titulo}</div>
              <div style={{ color:'#94a3b8', fontSize:13, whiteSpace:'pre-wrap' }}>{item.conteudo}</div>
              <div style={{ ...s.toolbar, marginTop:12, marginBottom:0 }}>
                <span style={s.badge(item.ativo ? '#22c55e' : '#64748b')}>{item.ativo ? 'Ativo' : 'Inativo'}</span>
                <button style={s.btn2} onClick={()=>setBaseEdit(item)}>Editar</button>
              </div>
            </div>
          ))}</div>
        </>
      )}

      {aba === 'regras' && (
        <>
          <div style={s.toolbar}><button style={s.btn} onClick={()=>setRegraEdit({ titulo:'', descricao:'', tipo:'orientacao', bloqueante:true, ativo:true })}>Nova regra</button></div>
          {regraEdit && <RegraForm atual={regraEdit.id ? regraEdit : null} onCancel={()=>setRegraEdit(null)} onSave={salvarRegra} />}
          <div style={s.card}>
            <table style={s.table}>
              <thead><tr>{['Regra','Descricao','Tipo','Limite','Status','Acao'].map(h=><th key={h} style={s.th}>{h}</th>)}</tr></thead>
              <tbody>{regras.map(r => (
                <tr key={r.id}>
                  <td style={s.td}>{r.titulo}</td>
                  <td style={s.td}>{r.descricao}</td>
                  <td style={s.td}>{r.tipo}</td>
                  <td style={s.td}><span style={s.badge(r.bloqueante ? '#ef4444' : '#38bdf8')}>{r.bloqueante ? 'Bloqueante' : 'Orientativa'}</span></td>
                  <td style={s.td}>{r.ativo ? 'Ativa' : 'Inativa'}</td>
                  <td style={s.td}><button style={s.btn2} onClick={()=>setRegraEdit(r)}>Editar</button></td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
